import { ref, computed, nextTick, onMounted, onActivated } from 'vue';
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, resolveDirective as _resolveDirective, isRef as _isRef, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8e6af892"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mainpage"
};
const _hoisted_2 = {
  class: "searchBlank"
};
const _hoisted_3 = {
  class: "search-blank-left"
};
const _hoisted_4 = {
  class: "item"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "t"
}, "产品名", -1));
const _hoisted_6 = {
  class: "appListPopover-content"
};
const _hoisted_7 = {
  class: "appListPopover-content-title"
};
const _hoisted_8 = {
  class: "inf-label"
};
const _hoisted_9 = {
  class: "inf-value"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "复制", -1));
const _hoisted_11 = {
  class: "item"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "t"
}, "渠道", -1));
const _hoisted_13 = {
  key: 0,
  class: "item"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "t"
}, "系统", -1));
const _hoisted_15 = {
  class: "item"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "t"
}, "商品信息", -1));
const _hoisted_17 = {
  class: "item"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "t"
}, "商品类型", -1));
const _hoisted_19 = {
  key: 1,
  class: "item"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "t"
}, "测试状态", -1));
const _hoisted_21 = {
  class: "item"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "t"
}, "审核状态", -1));
const _hoisted_23 = {
  class: "item"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "t"
}, "同步状态", -1));
const _hoisted_25 = {
  class: "item"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "t"
}, "商品状态", -1));
const _hoisted_27 = {
  class: "subBlock"
};
const _hoisted_28 = {
  class: "tableContent"
};
const _hoisted_29 = {
  key: 0,
  class: "optBlank"
};
const _hoisted_30 = {
  key: 1
};
const _hoisted_31 = {
  class: "optBlank"
};
const _hoisted_32 = {
  class: "btn-content"
};
import { SyncOutlined, DownOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { useRoute, useRouter } from 'vue-router';
import { watch } from 'vue';
import { getProdChannelCodeList, submitGoods, batchToggleThirdParty } from '@/api/goodsSetting';
import { syncProductFetch } from '@/api/sandbox';
import { useStore } from '@/store';
import useGetSelect from '@/hooks/useGetSelect';
import useListEvent from './hooks/useListEvent';
import { awaitWrap, getNode, OK, reportEvent, detailFields, searchFields, getAppListInformation, copy, isSandboxEnv } from '@/common';
import useDetailHooks from '@/views/goodsManage/goodsSetting/hooks/useDetailHooks';
import GoodExportModal from '@/views/goodsManage/goodsSetting/components/GoodExportModal.vue';
import WeiXinJudgeModal from '@/views/goodsManage/goodsSetting/components/WeiXinJudgeModal.vue';
import WeiXinGameJudgeModal from '@/views/goodsManage/goodsSetting/components/WeiXinGameJudgeModal.vue';
import { ProductSelect } from '@dbt/product-select';
import '@dbt/product-select/dist/style.css';
import FeishuExportModal from '@/views/goodsManage/goodsSetting/components/FeishuExportModal.vue';
import { defineComponent } from 'vue';
import RecordDrawer from './components/RecordDrawer.vue';
import TableContent from './components/TableContent.vue';
import CurrencyModal from './components/CurrencyModal.vue';
import { addCollectFetch, removeCollectFetch } from '@/api/payManage/appManage';
const __default__ = defineComponent({
  name: 'goodsSetting'
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const {
      productSelectRef,
      dbtProducts,
      judgeOptions,
      prodStatusOptions,
      publishOptions,
      getDbtProducts,
      filterOption
    } = useGetSelect(); // 接口数据源相关一系列内容
    const selectedRowKeys = ref([]);
    const route = useRoute();
    const router = useRouter();
    const {
      total,
      pageIndex,
      pageSize,
      searchForm,
      dynamicColumns,
      dataSource,
      appName,
      tableLoading,
      isDefault,
      cModal,
      canDelete,
      canDisable,
      canEnable,
      getData,
      searcher,
      goAdd,
      goDel,
      goUpd,
      goOnline,
      goOffline,
      exportGoodsExcel,
      changeDefault,
      queryExportType,
      batchOperate
    } = useListEvent(selectedRowKeys); // 列表事件,搜索项绑定等
    // 定义对象类型
    const {
      prodTypeOptions
    } = useDetailHooks();
    // 计算是否显示切换图标：渠道为google且第一个数据币种不是USD
    const showSwapIcon = computed(() => {
      return searchForm.value.prodChnl === 'google' && dataSource.value.length > 0 && dataSource.value[0].prodPriceCurrency !== 'USD';
    });
    const recordVisible = ref(false);
    const isUpdatingFromRoute = ref(false); // 防止路由变化时重复触发更新
    const osList = [{
      label: '全部',
      value: ''
    }, {
      label: '安卓',
      value: 1
    }, {
      label: 'ios',
      value: 2
    }];
    const gameGoodsList = ['weixin', 'kuaishou', 'alipay', 'amazom_google', 'zijie', 'BanHao', 'tiktok', 'blbl'];
    const gameGoodsValueList = ['weixin', 'kuaishou', 'alipay', 'amazom_google', 'zijie', 'tiktok', 'blbl'];
    const testStatusList = [{
      label: '全部',
      value: null
    }, {
      label: '测试',
      value: true
    }, {
      label: '正式',
      value: false
    }];
    const isGp = ref(true); // 判断商品是否为gp应用，false需要展示缺省
    const userInfo = computed(() => useStore().getParsedUserInfo);
    const modalVisible = ref(false);
    const judgeModal = ref(false);
    const judgeModalMore = ref(false);
    const loading = ref(false);
    const chnlOptions = ref([]);
    const judgeList = ref([]);
    const isToTest = ref(false);
    const syncLoading = ref(false);
    const feishuExportModalVisible = ref(false);
    const onSelectChange = keyArr => {
      selectedRowKeys.value = keyArr;
    }; // 勾选项
    const changeChnl = e => {
      if (isUpdatingFromRoute.value) return; // 如果是从路由更新来的，跳过
      searchForm.value.prodChnl = e;
      // 更新URL参数
      router.replace({
        query: {
          dbtId: searchForm.value.dbtId,
          prodChnl: searchForm.value.prodChnl
        }
      });
      dataSource.value = [];
      nextTick(() => {
        searcher();
      });
    }; // 变更选择渠道
    const changeDbtId = async () => {
      var _dbtProducts$value$fi;
      if (isUpdatingFromRoute.value) return; // 如果是从路由更新来的，跳过
      searchForm.value.prodChnl = '';
      selectedRowKeys.value = [];
      chnlOptions.value = [];
      appName.value = (_dbtProducts$value$fi = dbtProducts.value.find(item => item.value === searchForm.value.dbtId)) === null || _dbtProducts$value$fi === void 0 ? void 0 : _dbtProducts$value$fi.label;
      await getChnlOptions(searchForm.value.dbtId);
      // 更新URL参数
      router.replace({
        query: {
          dbtId: searchForm.value.dbtId,
          prodChnl: undefined // 清除渠道参数，因为产品改变后渠道会被重置
        }
      });
      if (chnlOptions.value.length) {
        changeChnl(chnlOptions.value[0].value);
        // 判断是否存在google渠道，没有就判断为非GP商品
        isGp.value = false;
        chnlOptions.value.forEach(item => {
          if (item.value === 'google') {
            isGp.value = true;
          }
        });
      } else {
        searcher();
      }
    }; // 变更选择的产品
    const submitJudge = async () => {
      loading.value = true;
      try {
        var _selectedRowKeys$valu;
        const params = {
          productList: ((_selectedRowKeys$valu = selectedRowKeys.value) === null || _selectedRowKeys$valu === void 0 ? void 0 : _selectedRowKeys$valu.map(item => {
            return {
              id: item
            };
          })) || []
        };
        const res = await submitGoods(params);
        if (res.code === '0') {
          message.success('提交成功');
          selectedRowKeys.value = [];
          getData();
          reportEvent({
            eventName: 'element_use',
            properties: {
              ui_name: '商品配置',
              element_name: '提交审核'
            }
          });
        }
      } catch (error) {}
      loading.value = false;
    }; // 提交审核
    const syncGoods = async () => {
      try {
        syncLoading.value = true;
        const res = await syncProductFetch({
          prodChnl: searchForm.value.prodChnl,
          dbtId: searchForm.value.dbtId
        });
        if (res.code === '0') {
          message.success('同步成功');
          getData();
          reportEvent({
            eventName: 'element_use',
            properties: {
              ui_name: '商品配置',
              element_name: '同步线上商品'
            }
          });
        }
      } catch (error) {} finally {
        syncLoading.value = false;
      }
    }; // 同步线上商品
    const reset = () => {
      searchForm.value = {
        dbtId: searchForm.value.dbtId,
        prodChnl: '',
        fuzzy: '',
        prodType: '',
        approvalStatuses: '',
        publishStatuses: '',
        prodStatus: ''
      };
      pageIndex.value = 1;
      selectedRowKeys.value = [];
      if (dbtProducts.value[0].value) {
        // changeDbtId(dbtProducts.value[0].value as string) // 默认选中第一个产品逻辑
      } else {
        searcher();
      }
    }; // 重置筛选条件
    const handleMenuClick = e => {
      if (e.key === 'exportGoods') {
        modalVisible.value = true;
      } else if (e.key === 'feishuExport') {
        feishuExportModalVisible.value = true;
      } else if (['1', '2', '3'].includes(e.key)) {
        batchOperate(e.key);
      }
    };
    const getChnlOptions = async dbtId => {
      const [err, res] = await awaitWrap(getProdChannelCodeList({
        dbtId
      }));
      if (err) return;
      if (res && res.code === OK) {
        var _res$data;
        chnlOptions.value = (_res$data = res.data) === null || _res$data === void 0 || (_res$data = _res$data.subChannelVoList) === null || _res$data === void 0 ? void 0 : _res$data.map(item => {
          return {
            label: item.channelName,
            value: item.channelCode
          };
        });
      }
    };
    const openModal = (flag = false) => {
      var _dataSource$value$fil;
      isToTest.value = flag;
      judgeList.value = (_dataSource$value$fil = dataSource.value.filter(item => selectedRowKeys.value.includes(item.id))) === null || _dataSource$value$fil === void 0 || (_dataSource$value$fil = _dataSource$value$fil.filter(item => item.modStatus)) === null || _dataSource$value$fil === void 0 ? void 0 : _dataSource$value$fil.filter(item => item.testStatus !== flag);
      if (!judgeList.value.length) {
        message.info('暂无需要审核的商品');
        return;
      }
      judgeModal.value = true;
    };
    const submitWeiXinJudge = () => {
      var _dataSource$value$fil2;
      judgeList.value = (_dataSource$value$fil2 = dataSource.value.filter(item => selectedRowKeys.value.includes(item.id))) === null || _dataSource$value$fil2 === void 0 ? void 0 : _dataSource$value$fil2.filter(item => !item.approvalStatus);
      if (!judgeList.value.length) {
        message.info('暂无需要审核的商品');
        return;
      }
      judgeModalMore.value = true;
    };
    const getEnjoyPayInfo = item => {
      var _channelPrices$priceI, _channelPrices$priceI2;
      const raw = item.channelPrices;
      if (!raw) return null;
      const channelPrices = typeof raw === 'string' ? JSON.parse(raw) : raw;
      return (_channelPrices$priceI = channelPrices === null || channelPrices === void 0 || (_channelPrices$priceI2 = channelPrices.priceInfo) === null || _channelPrices$priceI2 === void 0 ? void 0 : _channelPrices$priceI2.enjoy_pay) !== null && _channelPrices$priceI !== void 0 ? _channelPrices$priceI : null;
    };
    // 可开启：enableThirdPay 不为 true 且已设置三方价格
    const canEnableIds = computed(() => dataSource.value.filter(item => selectedRowKeys.value.includes(item.id)).filter(item => {
      const enjoyPay = getEnjoyPayInfo(item);
      return !(enjoyPay !== null && enjoyPay !== void 0 && enjoyPay.enableThirdPay) && !!(enjoyPay !== null && enjoyPay !== void 0 && enjoyPay.prodPrice);
    }).map(item => item.id));
    // 可关闭：enableThirdPay 为 true
    const canDisableIds = computed(() => dataSource.value.filter(item => selectedRowKeys.value.includes(item.id)).filter(item => {
      var _getEnjoyPayInfo;
      return ((_getEnjoyPayInfo = getEnjoyPayInfo(item)) === null || _getEnjoyPayInfo === void 0 ? void 0 : _getEnjoyPayInfo.enableThirdPay) === true;
    }).map(item => item.id));
    const handleToggleThirdParty = async enableThirdPay => {
      const ids = enableThirdPay ? canEnableIds.value : canDisableIds.value;
      if (!ids.length) {
        message.info(enableThirdPay ? '勾选项中无可开启三方支付的商品' : '勾选项中无可关闭三方支付的商品');
        return;
      }
      const productList = ids.map(id => ({
        id,
        payChnl: 'enjoy_pay',
        enableThirdPay
      }));
      const res = await batchToggleThirdParty({
        productList
      });
      if (res && res.code === '0') {
        message.success('操作成功');
      }
      selectedRowKeys.value = [];
      searcher();
    };
    const checkNum = computed(() => {
      return selectedRowKeys.value.filter(item => {
        var _dataSource$value$fin;
        return ((_dataSource$value$fin = dataSource.value.find(i => i.id === item)) === null || _dataSource$value$fin === void 0 ? void 0 : _dataSource$value$fin.approvalStatus) === 0;
      }).length;
    });
    const toTestNum = computed(() => {
      var _dataSource$value$fil3;
      return (_dataSource$value$fil3 = dataSource.value.filter(item => selectedRowKeys.value.includes(item.id))) === null || _dataSource$value$fil3 === void 0 || (_dataSource$value$fil3 = _dataSource$value$fil3.filter(item => item.modStatus)) === null || _dataSource$value$fil3 === void 0 || (_dataSource$value$fil3 = _dataSource$value$fil3.filter(item => !item.testStatus)) === null || _dataSource$value$fil3 === void 0 ? void 0 : _dataSource$value$fil3.length;
    });
    const toNoTestNum = computed(() => {
      var _dataSource$value$fil4;
      return (_dataSource$value$fil4 = dataSource.value.filter(item => selectedRowKeys.value.includes(item.id))) === null || _dataSource$value$fil4 === void 0 || (_dataSource$value$fil4 = _dataSource$value$fil4.filter(item => item.modStatus)) === null || _dataSource$value$fil4 === void 0 || (_dataSource$value$fil4 = _dataSource$value$fil4.filter(item => item.testStatus)) === null || _dataSource$value$fil4 === void 0 ? void 0 : _dataSource$value$fil4.length;
    });
    const handleFavorite = async (type, option) => {
      try {
        const fetchMethod = option.hasFavorite ? removeCollectFetch : addCollectFetch;
        if (!fetchMethod) {
          throw new Error('收藏方法未定义');
        }
        const {
          code
        } = await fetchMethod({
          dbtId: option.dbtId
        });
        if (code === '0') {
          message.success(`${option.hasFavorite ? '取消收藏' : '收藏'}成功`);
          option.hasFavorite = !option.hasFavorite;
        } else {
          throw new Error(`${option.hasFavorite ? '取消收藏' : '收藏'}失败`);
        }
      } catch (error) {
        console.error('收藏操作失败:', error);
        message.error('操作失败，请稍后重试');
      }
    }; // 添加收藏处理方法
    const closeCModal = () => {
      cModal.value = {
        visible: false,
        currency: ''
      };
    };
    // 批量按钮下拉过滤数量
    const batchFunc = value => {
      if (value) {
        canDelete.value = [];
        canDisable.value = [];
        canEnable.value = [];
        // 只循环一次，同时筛选出可删除、可停用、可启用的商品
        dataSource.value.forEach(item => {
          if (selectedRowKeys.value.includes(item.id)) {
            // approvalStatus != 30 prodStatus!= 10 replicaStatus!=1
            if (item.approvalStatus !== 30 && item.approvalStatus !== 10 && item.replicaStatus !== 1) {
              canDelete.value.push(item.id);
            }
            // prodStatus为10或true的可以停用prodStatus
            if (item.prodStatus === 10 && item.replicaStatus !== 1) {
              canDisable.value.push(item.id);
            }
            // prodStatus为20或replicaStatus!=1
            if (item.prodStatus === 20 && item.replicaStatus !== 1) {
              canEnable.value.push(item.id);
            }
          }
        });
      }
    };
    // 监听路由查询参数变化
    watch(() => route.query, async newQuery => {
      if (!newQuery.dbtId && !newQuery.prodChnl) return;
      isUpdatingFromRoute.value = true; // 设置标志，避免重复触发
      try {
        // 如果dbtId改变，需要重新获取渠道选项
        if (newQuery.dbtId !== searchForm.value.dbtId) {
          var _dbtProducts$value$fi2;
          searchForm.value.dbtId = newQuery.dbtId;
          searchForm.value.prodChnl = '';
          selectedRowKeys.value = [];
          chnlOptions.value = [];
          appName.value = (_dbtProducts$value$fi2 = dbtProducts.value.find(item => item.value === searchForm.value.dbtId)) === null || _dbtProducts$value$fi2 === void 0 ? void 0 : _dbtProducts$value$fi2.label;
          await getChnlOptions(searchForm.value.dbtId);
          // 判断是否存在google渠道
          isGp.value = false;
          chnlOptions.value.forEach(item => {
            if (item.value === 'google') {
              isGp.value = true;
            }
          });
        }
        // 如果prodChnl改变，更新表单并查询
        if (newQuery.prodChnl !== searchForm.value.prodChnl) {
          searchForm.value.prodChnl = newQuery.prodChnl;
          dataSource.value = [];
          nextTick(() => {
            searcher();
          });
        }
      } finally {
        isUpdatingFromRoute.value = false; // 重置标志
      }
    }, {
      deep: true
    });
    onMounted(async () => {
      await getDbtProducts(); // 产品下拉接口
      // 如果有URL参数，从URL参数初始化
      if (route.query && Object.keys(route.query).length > 0) {
        isUpdatingFromRoute.value = true; // 设置标志，避免重复触发
        try {
          searchForm.value.dbtId = route.query.dbtId;
          await getChnlOptions(searchForm.value.dbtId);
          if (chnlOptions.value.length) {
            searchForm.value.prodChnl = route.query.prodChnl;
            // 判断是否存在google渠道，没有就判断为非GP商品
            isGp.value = false;
            chnlOptions.value.forEach(item => {
              if (item.value === 'google') {
                isGp.value = true;
              }
            });
            dataSource.value = [];
            nextTick(() => {
              searcher();
            });
          } else {
            searcher();
          }
        } finally {
          isUpdatingFromRoute.value = false; // 重置标志
        }
      } else {
        // 从菜单进入，没有URL参数，默认选中第一个产品
        if (dbtProducts.value.length) {
          searchForm.value.dbtId = dbtProducts.value[0].value;
          await changeDbtId();
        }
      }
    });
    onActivated(() => {
      getData();
    });
    return (_ctx, _cache) => {
      var _unref2, _unref3;
      const _component_SvgIcon = _resolveComponent("SvgIcon");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_input_search = _resolveComponent("a-input-search");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_menu_item = _resolveComponent("a-menu-item");
      const _component_a_menu = _resolveComponent("a-menu");
      const _component_a_dropdown_button = _resolveComponent("a-dropdown-button");
      const _component_a_dropdown = _resolveComponent("a-dropdown");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_pagination = _resolveComponent("a-pagination");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_unref(ProductSelect), {
        ref_key: "productSelectRef",
        ref: productSelectRef,
        modelValue: _unref(searchForm).dbtId,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(searchForm).dbtId = $event),
        multiple: false,
        "show-icon": true,
        "show-extra": true,
        "search-fields": _unref(searchFields),
        "max-tag-count": 1,
        "show-detail": true,
        "allow-clear": false,
        layout: "vertical",
        descriptionField: "filePath",
        width: 200,
        "popup-class-name": "vertical-product-select",
        placeholder: "请选择",
        detailFields: _unref(detailFields),
        onChange: changeDbtId,
        "show-bottom-border": ""
      }, {
        icon: _withCtx(({
          type,
          option
        }) => [_createVNode(_component_SvgIcon, {
          iconClass: option.hasFavorite ? 'collectIcon' : 'collectGreyIcon',
          onClick: _withModifiers($event => handleFavorite(type, option), ["stop"]),
          class: "title-svg",
          style: {
            "margin": "0"
          }
        }, null, 8, ["iconClass", "onClick"])]),
        detail: _withCtx(({
          detail
        }) => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_SvgIcon, {
          iconClass: "informationIcon",
          class: "informationIcon"
        }), _createTextVNode(" " + _toDisplayString(detail.label), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAppListInformation)(detail.extData), child => {
          return _openBlock(), _createElementBlock("div", {
            key: child.label,
            class: "inf-line"
          }, [_createElementVNode("div", _hoisted_8, _toDisplayString(child.label) + "：", 1), _createElementVNode("div", _hoisted_9, _toDisplayString(child.value), 1), _createVNode(_component_a_tooltip, {
            placement: "top"
          }, {
            title: _withCtx(() => [_hoisted_10]),
            default: _withCtx(() => [_createVNode(_component_SvgIcon, {
              iconClass: "copy",
              class: "dbt-copyIcon",
              onClick: $event => _unref(copy)(child.value)
            }, null, 8, ["onClick"])]),
            _: 2
          }, 1024)]);
        }), 128))])]),
        _: 1
      }, 8, ["modelValue", "search-fields", "detailFields"])]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createVNode(_component_a_select, {
        class: "searchItem",
        value: _unref(searchForm).prodChnl,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => _unref(searchForm).prodChnl = $event),
        options: chnlOptions.value,
        "filter-option": _unref(filterOption),
        onChange: changeChnl,
        "get-popup-container": _unref(getNode),
        placeholder: "请选择"
      }, null, 8, ["value", "options", "filter-option", "get-popup-container"])]), ['weixin'].includes(_unref(searchForm).prodChnl) ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_hoisted_14, _createVNode(_component_a_select, {
        class: "searchItem",
        value: _unref(searchForm).os,
        "onUpdate:value": _cache[2] || (_cache[2] = $event => _unref(searchForm).os = $event),
        options: osList,
        "filter-option": _unref(filterOption),
        "get-popup-container": _unref(getNode),
        placeholder: "请选择"
      }, null, 8, ["value", "filter-option", "get-popup-container"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createVNode(_component_a_input_search, {
        class: "searchItem",
        value: _unref(searchForm).fuzzy,
        "onUpdate:value": _cache[3] || (_cache[3] = $event => _unref(searchForm).fuzzy = $event),
        valueModifiers: {
          trim: true
        },
        placeholder: "请输入内购ID/备注",
        onSearch: _unref(searcher)
      }, null, 8, ["value", "onSearch"])]), _createElementVNode("div", _hoisted_17, [_hoisted_18, _createVNode(_component_a_select, {
        class: "searchItem",
        value: _unref(searchForm).prodType,
        "onUpdate:value": _cache[4] || (_cache[4] = $event => _unref(searchForm).prodType = $event),
        options: [{
          label: '全部',
          value: ''
        }, ..._unref(prodTypeOptions)],
        "filter-option": _unref(filterOption),
        "get-popup-container": _unref(getNode),
        placeholder: "请选择",
        onChange: _unref(searcher)
      }, null, 8, ["value", "options", "filter-option", "get-popup-container", "onChange"])]), ['weixin', 'kuaishou', 'alipay', 'zijie', 'blbl'].includes(_unref(searchForm).prodChnl) ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_hoisted_20, _createVNode(_component_a_select, {
        class: "searchItem",
        value: _unref(searchForm).testStatus,
        "onUpdate:value": _cache[5] || (_cache[5] = $event => _unref(searchForm).testStatus = $event),
        options: testStatusList,
        "filter-option": _unref(filterOption),
        "get-popup-container": _unref(getNode),
        placeholder: "请选择"
      }, null, 8, ["value", "filter-option", "get-popup-container"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_21, [_hoisted_22, _createVNode(_component_a_select, {
        class: "searchItem",
        value: _unref(searchForm).approvalStatuses,
        "onUpdate:value": _cache[6] || (_cache[6] = $event => _unref(searchForm).approvalStatuses = $event),
        options: _unref(judgeOptions),
        "filter-option": _unref(filterOption),
        "get-popup-container": _unref(getNode),
        placeholder: "请选择",
        onChange: _unref(searcher)
      }, null, 8, ["value", "options", "filter-option", "get-popup-container", "onChange"])]), _createElementVNode("div", _hoisted_23, [_hoisted_24, _createVNode(_component_a_select, {
        class: "searchItem",
        value: _unref(searchForm).publishStatuses,
        "onUpdate:value": _cache[7] || (_cache[7] = $event => _unref(searchForm).publishStatuses = $event),
        options: _unref(publishOptions),
        "filter-option": _unref(filterOption),
        "get-popup-container": _unref(getNode),
        placeholder: "请选择",
        onChange: _unref(searcher)
      }, null, 8, ["value", "options", "filter-option", "get-popup-container", "onChange"])]), _createElementVNode("div", _hoisted_25, [_hoisted_26, _createVNode(_component_a_select, {
        class: "searchItem",
        value: _unref(searchForm).prodStatus,
        "onUpdate:value": _cache[8] || (_cache[8] = $event => _unref(searchForm).prodStatus = $event),
        options: _unref(prodStatusOptions),
        "filter-option": _unref(filterOption),
        "get-popup-container": _unref(getNode),
        placeholder: "请选择",
        onChange: _unref(searcher)
      }, null, 8, ["value", "options", "filter-option", "get-popup-container", "onChange"])])]), _createElementVNode("div", _hoisted_27, [_createVNode(_component_a_button, {
        class: "subBtn",
        onClick: reset
      }, {
        default: _withCtx(() => [_createTextVNode("重置")]),
        _: 1
      }), _createVNode(_component_a_button, {
        type: "primary",
        class: "subBtn",
        onClick: _unref(searcher)
      }, {
        default: _withCtx(() => [_createTextVNode("搜索")]),
        _: 1
      }, 8, ["onClick"])])]), _createElementVNode("div", _hoisted_28, [_unref(isSandboxEnv) ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createVNode(_component_a_button, {
        onClick: syncGoods
      }, {
        icon: _withCtx(() => [_createVNode(_unref(SyncOutlined), {
          spin: syncLoading.value,
          class: "refresh_icon"
        }, null, 8, ["spin"])]),
        default: _withCtx(() => [_createTextVNode(" 同步线上商品 ")]),
        _: 1
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_30, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createVNode(_component_a_dropdown_button, {
        onClick: _unref(goAdd),
        disabled: !_unref(searchForm).prodChnl,
        type: "primary"
      }, {
        overlay: _withCtx(() => [_createVNode(_component_a_menu, {
          onClick: handleMenuClick
        }, {
          default: _withCtx(() => [_createVNode(_component_a_menu_item, {
            key: "feishuExport",
            style: {
              "width": "112px"
            }
          }, {
            default: _withCtx(() => [_createTextVNode("飞书导入")]),
            _: 1
          }), _createVNode(_component_a_menu_item, {
            key: "exportGoods",
            style: {
              "width": "112px"
            }
          }, {
            default: _withCtx(() => [_createTextVNode("文件导入")]),
            _: 1
          })]),
          _: 1
        })]),
        icon: _withCtx(() => [_createVNode(_component_SvgIcon, {
          "icon-class": "arrow",
          "class-name": "arrow-down"
        })]),
        default: _withCtx(() => [_createTextVNode(" 新增商品 ")]),
        _: 1
      }, 8, ["onClick", "disabled"]), !gameGoodsList.includes(_unref(searchForm).prodChnl) ? (_openBlock(), _createBlock(_component_a_button, {
        key: 0,
        type: "primary",
        ghost: "",
        disabled: !_unref(checkNum),
        class: "btn",
        loading: loading.value,
        onClick: submitJudge
      }, {
        default: _withCtx(() => [_createTextVNode(" 提交审核 "), _withDirectives(_createElementVNode("span", null, "(" + _toDisplayString(_unref(checkNum)) + ")", 513), [[_vShow, _unref(checkNum) > 0]])]),
        _: 1
      }, 8, ["disabled", "loading"])) : _createCommentVNode("", true), gameGoodsList.includes(_unref(searchForm).prodChnl) ? (_openBlock(), _createBlock(_component_a_button, {
        key: 1,
        type: "primary",
        ghost: "",
        disabled: !_unref(checkNum),
        class: "btn",
        onClick: submitWeiXinJudge
      }, {
        default: _withCtx(() => [_createTextVNode(" 提交审核 "), _withDirectives(_createElementVNode("span", null, "(" + _toDisplayString(_unref(checkNum)) + ")", 513), [[_vShow, _unref(checkNum) > 0]])]),
        _: 1
      }, 8, ["disabled"])) : _createCommentVNode("", true), _unref(searchForm).prodChnl === 'apple' ? (_openBlock(), _createBlock(_component_a_button, {
        key: 2,
        type: "primary",
        ghost: "",
        disabled: !_unref(canEnableIds).length,
        class: "btn",
        onClick: _cache[9] || (_cache[9] = $event => handleToggleThirdParty(true))
      }, {
        default: _withCtx(() => [_createTextVNode(" 开启三方支付 "), _withDirectives(_createElementVNode("span", null, "(" + _toDisplayString(_unref(canEnableIds).length) + ")", 513), [[_vShow, _unref(canEnableIds).length > 0]])]),
        _: 1
      }, 8, ["disabled"])) : _createCommentVNode("", true), _unref(searchForm).prodChnl === 'apple' ? (_openBlock(), _createBlock(_component_a_button, {
        key: 3,
        type: "primary",
        ghost: "",
        disabled: !_unref(canDisableIds).length,
        class: "btn",
        onClick: _cache[10] || (_cache[10] = $event => handleToggleThirdParty(false))
      }, {
        default: _withCtx(() => [_createTextVNode(" 关闭三方支付 "), _withDirectives(_createElementVNode("span", null, "(" + _toDisplayString(_unref(canDisableIds).length) + ")", 513), [[_vShow, _unref(canDisableIds).length > 0]])]),
        _: 1
      }, 8, ["disabled"])) : _createCommentVNode("", true), gameGoodsValueList.includes(_unref(searchForm).prodChnl) ? (_openBlock(), _createBlock(_component_a_button, {
        key: 4,
        type: "primary",
        ghost: "",
        disabled: !_unref(toTestNum),
        class: "btn",
        onClick: _cache[11] || (_cache[11] = $event => openModal(true))
      }, {
        default: _withCtx(() => [_createTextVNode(" 改为测试价格 "), _withDirectives(_createElementVNode("span", null, "(" + _toDisplayString(_unref(toTestNum)) + ")", 513), [[_vShow, _unref(toTestNum) > 0]])]),
        _: 1
      }, 8, ["disabled"])) : _createCommentVNode("", true), gameGoodsValueList.includes(_unref(searchForm).prodChnl) ? (_openBlock(), _createBlock(_component_a_button, {
        key: 5,
        type: "primary",
        ghost: "",
        disabled: !_unref(toNoTestNum),
        class: "btn",
        onClick: _cache[12] || (_cache[12] = $event => openModal(false))
      }, {
        default: _withCtx(() => [_createTextVNode(" 回归正式价格 "), _withDirectives(_createElementVNode("span", null, "(" + _toDisplayString(_unref(toNoTestNum)) + ")", 513), [[_vShow, _unref(toNoTestNum) > 0]])]),
        _: 1
      }, 8, ["disabled"])) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createElementBlock("div", null, [_createVNode(_component_a_dropdown, {
        class: "batch-btn",
        onOpenChange: batchFunc
      }, {
        overlay: _withCtx(() => [_createVNode(_component_a_menu, {
          onClick: handleMenuClick
        }, {
          default: _withCtx(() => [_createVNode(_component_a_menu_item, {
            key: "1",
            disabled: !_unref(canDelete).length
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(canDelete).length ? `批量删除(${_unref(canDelete).length})` : '批量删除'), 1)]),
            _: 1
          }, 8, ["disabled"]), _createVNode(_component_a_menu_item, {
            key: "2",
            disabled: !_unref(canDisable).length
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(canDisable).length ? `批量停用(${_unref(canDisable).length})` : '批量停用'), 1)]),
            _: 1
          }, 8, ["disabled"]), _createVNode(_component_a_menu_item, {
            key: "3",
            disabled: !_unref(canEnable).length
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(canEnable).length ? `批量启用(${_unref(canEnable).length})` : '批量启用'), 1)]),
            _: 1
          }, 8, ["disabled"])]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_a_button, null, {
          default: _withCtx(() => [_createTextVNode(" 批量操作 "), _createVNode(_unref(DownOutlined))]),
          _: 1
        })]),
        _: 1
      })])), [[_directive_permission, {
        permissionValue: 'goodsSetting',
        permissionArr: (_unref2 = _unref(userInfo)) === null || _unref2 === void 0 ? void 0 : _unref2.permissions
      }]])]), _createVNode(_component_a_button, {
        onClick: _unref(queryExportType)
      }, {
        icon: _withCtx(() => [_createVNode(_component_svg_icon, {
          "icon-class": "export",
          "class-name": "export-icon"
        })]),
        default: _withCtx(() => [_createTextVNode(" 导出 ")]),
        _: 1
      }, 8, ["onClick"])])), [[_directive_permission, {
        permissionValue: 'goodsSetting',
        permissionArr: (_unref3 = _unref(userInfo)) === null || _unref3 === void 0 ? void 0 : _unref3.permissions
      }]])])), _createVNode(TableContent, {
        class: "tableBody",
        columns: _unref(dynamicColumns)(),
        dataSource: _unref(dataSource).slice((_unref(pageIndex) - 1) * _unref(pageSize), _unref(pageIndex) * _unref(pageSize)),
        isGp: isGp.value,
        selectedRowKeys: selectedRowKeys.value,
        prodChnl: _unref(searchForm).prodChnl,
        isDefault: _unref(isDefault),
        showSwapIcon: _unref(showSwapIcon),
        onOnSelectChange: onSelectChange,
        onGoDel: _unref(goDel),
        onGoOffline: _unref(goOffline),
        onGoOnline: _unref(goOnline),
        onGoUpd: _unref(goUpd),
        onChangeChnl: _unref(changeDefault),
        loading: _unref(tableLoading)
      }, null, 8, ["columns", "dataSource", "isGp", "selectedRowKeys", "prodChnl", "isDefault", "showSwapIcon", "onGoDel", "onGoOffline", "onGoOnline", "onGoUpd", "onChangeChnl", "loading"]), _createVNode(_component_a_pagination, {
        class: "paginationBlock",
        current: _unref(pageIndex),
        "onUpdate:current": _cache[13] || (_cache[13] = $event => _isRef(pageIndex) ? pageIndex.value = $event : null),
        pageSize: _unref(pageSize),
        "onUpdate:pageSize": _cache[14] || (_cache[14] = $event => _isRef(pageSize) ? pageSize.value = $event : null),
        total: _unref(total),
        "show-size-changer": "",
        "show-total": total => `共 ${total} 条`
      }, null, 8, ["current", "pageSize", "total", "show-total"])]), _createVNode(GoodExportModal, {
        "modal-visible": modalVisible.value,
        "onUpdate:modal-visible": _cache[15] || (_cache[15] = $event => modalVisible.value = $event),
        "dbt-id": _unref(searchForm).dbtId,
        "prod-chnl": _unref(searchForm).prodChnl,
        onUpdateList: _unref(searcher)
      }, null, 8, ["modal-visible", "dbt-id", "prod-chnl", "onUpdateList"]), _createVNode(FeishuExportModal, {
        "dbt-id": _unref(searchForm).dbtId,
        "prod-chnl": _unref(searchForm).prodChnl,
        "modal-visible": feishuExportModalVisible.value,
        "onUpdate:modal-visible": _cache[16] || (_cache[16] = $event => feishuExportModalVisible.value = $event),
        onRefresh: _unref(searcher)
      }, null, 8, ["dbt-id", "prod-chnl", "modal-visible", "onRefresh"]), _createVNode(WeiXinJudgeModal, {
        "modal-visible": judgeModal.value,
        "onUpdate:modal-visible": _cache[17] || (_cache[17] = $event => judgeModal.value = $event),
        "data-source": judgeList.value,
        "is-to-test": isToTest.value,
        onSearchData: _unref(searcher),
        "prod-chnl": _unref(searchForm).prodChnl
      }, null, 8, ["modal-visible", "data-source", "is-to-test", "onSearchData", "prod-chnl"]), _createVNode(WeiXinGameJudgeModal, {
        "modal-visible": judgeModalMore.value,
        "onUpdate:modal-visible": _cache[18] || (_cache[18] = $event => judgeModalMore.value = $event),
        "data-source": judgeList.value,
        onSearchData: _unref(searcher),
        "prod-chnl": _unref(searchForm).prodChnl
      }, null, 8, ["modal-visible", "data-source", "onSearchData", "prod-chnl"]), _createVNode(RecordDrawer, {
        visible: recordVisible.value,
        "onUpdate:visible": _cache[19] || (_cache[19] = $event => recordVisible.value = $event)
      }, null, 8, ["visible"]), _createVNode(CurrencyModal, _mergeProps(_unref(cModal), {
        onCloseModal: closeCModal,
        onOkModal: _unref(exportGoodsExcel)
      }), null, 16, ["onOkModal"])]);
    };
  }
});